import { createUseStyles } from 'react-jss';
import { mechaColours } from '../mecha_styles';

export const useStyles = createUseStyles({
    // TODO: extend to handle different alert types.
    // See mecha_hero_button_styles.js for css inspo
    mecha_alert_banner_wrapper: ({ justify, darkRed }) => ({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: justify || 'center',
        padding: '16px',
        gap: '12px',
        marginTop: '2rem',
        backgroundColor: darkRed ? mechaColours.error100 : mechaColours.error50,
        borderColor: mechaColours.borderPrimary,
        color: mechaColours.greyscale800,
        borderRadius: '4px',
        '@media only screen and (max-width: 600px)': {
            padding: '12px'
        }
    }),
    mecha_alert_banner_icon: {
        color: mechaColours.error500,
        height: '18px'
    },
    mecha_alert_banner_content: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '160%',
        letterSpacing: '0.3px',
        margin: '0'
    },
    bold_content: {
        fontWeight: '600'
    },
    mecha_alert_banner_header: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '160%',
        letterSpacing: '0.3px',
        margin: '0'
    },
    mecha_alert_banner_content_wrapper: {
        display: 'flex',
        flexDirection: 'column'
    },
    linkText: {
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});
